module.exports = __webpack_public_path__ + "e5503bd329b95a91b4a3f4f7fe468080.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2022-09-08/whats-new.html
// module id = 2340
// module chunks = 0